export default __webpack_public_path__ + "static/tr-88e16769d00868ecd9b2592a5e306d03.svg";